import { useEffect, useState } from 'react'

interface CountdownType {
  endTime: number
  className?: string
}
const CountdownFlashSale = ({ endTime, className }: CountdownType) => {
  const savedTime = new Date(endTime)
  const countDownDate = new Date(savedTime).getTime()
  const [countDown, setCountDown] = useState(
    countDownDate - new Date().getTime()
  )
  const [days, setDays] = useState(0)
  const [hours, setHours] = useState(0)
  const [minutes, setMinutes] = useState(0)
  const [seconds, setSeconds] = useState(0)

  useEffect(() => {
    setDays(Math.floor(countDown / (1000 * 60 * 60 * 24)))
    setHours(
      Math.floor(
        (countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60) + days * 24
      )
    )
    setMinutes(Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60)))
    setSeconds(Math.floor((countDown % (1000 * 60)) / 1000))
  }, [countDown])
  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown(countDownDate - new Date().getTime())
      if (countDownDate - new Date().getTime() < 0) {
        setDays(0)
        setHours(0)
        setMinutes(0)
        setSeconds(0)
        setCountDown(0)
        
        clearInterval(interval)
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [countDownDate])
  return (
    <div
      className={`countDownFlashSale ${className}`}
    >
      {hours < 10 ? (
        <div
          className={`formCountTime flex items-center justify-center `}
        >
          <span className={'block'}>0</span>
          <span className={'block'}>{hours}</span>
        </div>
      ) : hours >= 24 ? (
        <div
          className={`formCountTime flex items-center justify-center `}
        >
          {hours % 24 > 10 ? (
            <>
              <span className={'block'}>{`${hours % 24}`?.charAt(0)}</span>
              <span className={'block'}>{`${hours % 24}`?.charAt(1)}</span>
            </>
          ) : (
            <>
              <span className={'block'}>0</span>
              <span className={'block'}>{`${hours % 24}`?.charAt(0)}</span>
            </>
          )}
        </div>
      ) : (
        <div
          className={`formCountTime flex items-center justify-center `}
        >
          <span className={'block'}>{`${hours}`?.charAt(0)}</span>
          <span className={'block'}>{`${hours}`?.charAt(1)}</span>
        </div>
      )}
      <span
        className={`delimiter`}
      >
        :
      </span>
      {minutes < 10 ? (
        <div
          className={`formCountTime flex items-center justify-center `}
        >
          <span className={'block'}>0</span>
          <span className={'block'}>{minutes}</span>
        </div>
      ) : (
        <div
          className={`formCountTime flex items-center justify-center `}
        >
          <span className={'block'}>{`${minutes}`?.charAt(0)}</span>
          <span className={'block'}>{`${minutes}`?.charAt(1)}</span>
        </div>
      )}
      <span
        className={`delimiter`}
      >
        :
      </span>
      {seconds < 10 ? (
        <div
          className={`formCountTime flex items-center justify-center `}
        >
          <span className={'block'}>0</span>
          <span className={'block'}>{seconds}</span>
        </div>
      ) : (
        <div
          className={`formCountTime flex items-center justify-center `}
        >
          <span className={'block'}>{`${seconds}`?.charAt(0)}</span>
          <span className={'block'}>{`${seconds}`?.charAt(1)}</span>
        </div>
      )}
    </div>
  )
}

export default CountdownFlashSale
